function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef, memo, useRef, useEffect } from 'react';
import { format } from 'date-fns';
import Inputmask from 'inputmask';
import PropTypes from 'prop-types';
import useMergeRefs from '../../../../../components/Utils/customHooks/useMergeRefs';
import { TextInput } from '../TextInput';
import { getInputMaskOptions } from '@dtsl/react/dist/components/DatePickers/utils/helper';

// eslint-disable-next-line react/display-name
const DateInput = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    actions = null,
    disabled = false,
    readOnly = false,
    placeholder = 'DD/MM/YYYY',
    dateFormat = 'dd/MM/yyyy',
    onBlur = () => {},
    selectedDate = '',
    ...restProps
  } = props;
  const dateInputRef = useRef();
  const mergedRef = useMergeRefs(dateInputRef, ref);
  useEffect(() => {
    if (dateInputRef.current) {
      Inputmask({
        ...getInputMaskOptions(dateFormat, placeholder)
      }).mask(dateInputRef.current);
    }
  }, [dateFormat, placeholder]);
  useEffect(() => {
    if (dateInputRef?.current) {
      if (selectedDate) {
        const dateValue = format(selectedDate, dateFormat);
        dateInputRef.current.value = dateValue || '';
      } else {
        dateInputRef.current.value = '';
      }
    }
  }, [selectedDate]);
  return /*#__PURE__*/React.createElement(TextInput, _extends({}, restProps, {
    prefix: null,
    suffix: null,
    actions: actions,
    maxCharCount: null,
    ref: mergedRef,
    placeholder: placeholder ? placeholder : dateFormat,
    readOnly: readOnly,
    disabled: disabled,
    "data-inputmask-alias": "date",
    "data-inputmask-inputformat": placeholder ? placeholder : dateFormat,
    "im-insert": "false",
    onBlur: onBlur
  }));
});
DateInput.propTypes = {
  actions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.arrayOf(PropTypes.func)]),
  value: PropTypes.string,
  selectedDate: PropTypes.instanceOf(Date),
  placeholder: PropTypes.string,
  dateFormat: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onBlur: PropTypes.func
};
export default /*#__PURE__*/memo(DateInput);